/**
 * 选图模态框
 */
import React, { useEffect, useState } from 'react';
import H5CommonComponent from '@tencent/h5-common-component';
import Modal from '../Modal';
import style from './index.module.scss';
import CloseBtn from './static/close.png';
const ChooseImageModal = ({ tipImage, isShowMask, onChooseImageInfo, onHandleCloseStatus, }) => {
    const [modalStatus, setModalstatus] = useState(isShowMask);
    useEffect(() => {
        setModalstatus(isShowMask);
    }, [isShowMask]);
    const onCameraClick = () => {
        window.mqq.invoke('aecamera', 'takePhoto', {
            outMaxWidth: 800,
            outMaxHeight: 800,
        }, (data) => {
            if (data.succeeded) {
                let base64 = data.picData;
                onChooseImageInfo(data.picData, 'shoot');
            }
        });
    };
    const onAlbumClick = () => {
        const imagePickerInstance = new H5CommonComponent.ImagePickerEnhance();
        imagePickerInstance.chooseImage((imageData) => {
            onChooseImageInfo(imageData, 'album');
        });
        // window.mqq.invoke(
        //   'media',
        //   'getPicture',
        //   {
        //     source: 0,
        //     front: false,
        //     max: 1,
        //     outMaxWidth: 600,
        //     outMaxHeight: 600,
        //     inMinWidth: 100,
        //     inMinHeight: 100,
        //     urlOnly: false
        //   },
        //   (ret: any, data: any) => {
        //     let base64 = data[0].data;
        //     onChooseImageInfo(base64, 'album');
        //   }
        // )
    };
    const onClickClose = () => {
        setModalstatus(false);
        onHandleCloseStatus(false);
    };
    const getModalContent = () => (React.createElement("div", { className: style.operate },
        React.createElement("div", { className: style['indicator-img'], style: { backgroundImage: `url(${tipImage})` } }),
        React.createElement("div", { className: style['modal-text'] }, "\u8BF7\u4E0A\u4F20\u6B63\u8138\u7167\u6548\u679C\u6700\u4F73"),
        React.createElement("div", { className: style['operate-wrapper'] },
            React.createElement("div", { className: style['container'] },
                React.createElement("div", { className: style.camera, onClick: onCameraClick }, "\u62CD\u7167"),
                React.createElement("div", { className: style.album, onClick: onAlbumClick }, "\u9009\u56FE"))),
        React.createElement("img", { src: CloseBtn, className: style.close, onClick: onClickClose })));
    return React.createElement(Modal, { content: getModalContent(), visible: modalStatus, hideModal: onClickClose });
};
export default ChooseImageModal;
